import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, timeout } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * Cuanto se espera la evaluacion antes de seguir de largo.
 *
 * Corre dentro del spinner del login, asi que no puede quedarse colgado: por
 * dentro el backend consulta el PEP contra un proveedor externo. Si tarda mas
 * que esto, el usuario entra igual y el barrido periodico lo aprueba despues.
 */
const TIMEOUT_MS = 8000;

@Injectable({
  providedIn: 'root',
})
export class AutoApprovalService {
  private baseUrl = environment.apiNest;

  constructor(private http: HttpClient) {}

  /**
   * Pide la evaluacion del registro propio, para el usuario ya autenticado.
   *
   * Va con `X-Skip-Error-Interceptor` a proposito: sin eso, cualquier 401 de
   * este llamado dispararia el interceptor global y sacaria al usuario de la
   * sesion justo despues de haber entrado.
   *
   * Nunca tira: si algo falla, devuelve `false` y el login sigue su curso
   * normal. Esta funcion solo puede mejorar la experiencia, nunca romperla.
   */
  async evaluarMiRegistro(): Promise<boolean> {
    const url = `${this.baseUrl}auto-approval-client/mi-registro`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Skip-Error-Interceptor': '1',
    });

    try {
      const res = await firstValueFrom(
        this.http
          .post<{ aprobado: boolean }>(url, {}, { headers })
          .pipe(timeout(TIMEOUT_MS)),
      );
      return res?.aprobado === true;
    } catch {
      return false;
    }
  }
}
